export default "__VITE_ASSET__jejkAgOR__"